<template>
    <div class="modal fade" id="gdprModal" tabindex="-1" aria-labelledby="updatesModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
            <div class="modal-content modal_wrapper">
                <div class="modal-header border-0">
                    <h2 class="title" id="updatesModalLabel">{{ $t('general.bussinessTermsChanged') }}</h2>
                </div>
                <div class="modal-body box">
                    <div v-if="user" class="mb-3">
                        <p>
                            Přečíst si je můžete zde:
                        </p>
                        <p>
                            <a :href="$router.resolve({ name: 'BussinessTermsActual' }).href" target="_blank"
                            style="color: black;">
                                Aktuální obchodní podmínky</a>
                        </p>
                    </div>
                </div>
                <div class="modal-footer border-0">
                    <button type="button" class="btn btn_main px-5" @click="submitSeen">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from "bootstrap"; // Import Bootstrap's modal class

export default {
    data() {
        return {
            user: {},
            modalInstance: null,
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            // Some api call is for some reason needed for the correct working of the modal
            this.$store.getters.api.get('/auth/user').then(res => {
                this.user = res.data.user;
                this.showModal();
            })
        },
        showModal() {
            const modalElement = document.getElementById("gdprModal");

            // Remove existing backdrops to prevent duplication
            document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());

            if (!this.modalInstance && modalElement) {
                this.modalInstance = new Modal(modalElement, { backdrop: "static", keyboard: false });
            }

            // Check if the modal is not already shown
            if (modalElement && !modalElement.classList.contains("show")) {
                this.modalInstance.show();
            }
        },
        submitSeen() {
            this.$store.getters.api.post(`/gdpr/user/${this.user.id}/seen`).then(res => {
                if (this.modalInstance) {
                    this.modalInstance.hide();
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.modal_wrapper {
    padding: 15px 30px 15px 30px;
    border-radius: $radius-xl;

    .modal-body {
        border-radius: $radius-lg;
        padding: 15px 30px 30px 30px;
    }
}
</style>